import React from 'react';
import PropTypes from 'prop-types';

import ProductPropertyTab, { PropertyList } from '../../molecules/product-detail-accordion';

const DETAIL_PROPERTIES_VALUES = [
  'Maisonette Product ID',
  'Assembly Required',
  'Made to Order',
  'Country of Origin'
];

const Details = ({ product, variant, details }) => {
  const parsedDetails = (() => {
    if (!details.length) return null;

    const propObject = (value, name, id) => ({
      id,
      name,
      value
    });

    const detailsArray = details.reduce((acc, property) => {
      if (property.value.toLowerCase() === 'no') return acc;

      const obj = property.property_name === DETAIL_PROPERTIES_VALUES[0]
        ? propObject(`Item number ${property.value}`, property.property_name, property.id)
        : propObject(property.value, property.property_name, property.id);

      acc.push(obj);
      return acc;
    }, []);

    if (variant) {
      if (parseFloat(variant.weight)) {
        detailsArray.push(propObject(variant.weight, 'Weight', 'weight'));
      }

      if (parseFloat(variant.height)) {
        detailsArray.push(propObject(variant.height, 'Height', 'height'));
      }

      if (parseFloat(variant.width)) {
        detailsArray.push(propObject(variant.width, 'Width', 'width'));
      }

      if (parseFloat(variant.depth)) {
        detailsArray.push(propObject(variant.depth, 'Depth', 'depth'));
      }
    }

    return detailsArray;
  })();

  return (parsedDetails && parsedDetails.length > 0) ? (
    <ProductPropertyTab title="Details" product={product}>
      <PropertyList element="ul" like="dec-4">
        {
          parsedDetails.map((item) => (
            <li key={item.id}>{`${item.name}: ${item.value}`}</li>
          ))
        }
      </PropertyList>
    </ProductPropertyTab>
  ) : null;
};

Details.defaultProps = {
  variant: null,
  details: []
};

Details.propTypes = {
  variant: PropTypes.object,
  details: PropTypes.array,
  product: PropTypes.object.isRequired
};

export default Details;
